import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import {withStyles} from '@material-ui/core/styles';
import Info from '@material-ui/icons/Info';
import {Link} from 'react-router-dom'
import Utility from "../../Utility";
import Tooltip from "@material-ui/core/Tooltip";

const styles = theme => ({
    root: {
        overflowX: 'auto',
    },
    tableCell: {
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            fontSize: '10px',
            padding: '4px 12px 4px 12px',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
            padding: '4px 16px 4px 16px',
        },
        [theme.breakpoints.up('lg')]: {
            fontSize: '18px',
            padding: '4px 24px 4px 24px',
        },
    },
    noData: {
        padding: theme.spacing.unit,
    },

    cancelReasonStyle: {
        textAlign: 'center',
    }
});



const CustomTooltip = withStyles(theme => ({
    tooltip: {
        backgroundColor: '#ffffff',
        color: '#000000',
        fontSize: theme.typography.pxToRem(14),
        border: '1px solid #3f51b5',
        position: 'relative',
    },
}))(Tooltip);

class RequestListTable extends React.Component {
    render(){
        if(this.props.list === undefined || this.props.list === null || this.props.list.length === 0){
            return (
                <div className={this.props.classes.root}>
                    <div className={this.props.classes.noData}>データなし</div>
                </div>
            );
        }
        else{
            return (
                <div className={this.props.classes.root}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={this.props.classes.tableCell}>詳細</TableCell>
                                <TableCell className={this.props.classes.tableCell}>配車期間</TableCell>
                                <TableCell className={this.props.classes.tableCell}>協力会社名</TableCell>
                                <TableCell className={this.props.classes.tableCell}>配車先</TableCell>
                                <TableCell className={this.props.classes.tableCell}>台数</TableCell>
                                <TableCell className={this.props.classes.tableCell}>ステータス</TableCell>
                                {this.props.detailPath === '/cancelRequestDetail' && (<TableCell className={this.props.classes.tableCell}>キャンセル理由</TableCell>)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.list.map((row, i) =>{
                                const DetailLink = props => <Link to={{pathname: this.props.detailPath, search: "?objectId=" + row.transactionId}} {...props}/>;
                                return (
                                    <TableRow key={i}>
                                        <TableCell align="left" className={this.props.classes.tableCell}>
                                            <IconButton color="primary" component={DetailLink}>
                                                <Info fontSize="large"/>
                                            </IconButton>
                                        </TableCell>
                                        <TableCell className={this.props.classes.tableCell}>{Utility.formatDate(Utility.toDate(row.expectedUseStartDate), 'yyyy/MM/dd') + '～' + Utility.formatDate(Utility.toDate(row.expectedReturnDate), 'yyyy/MM/dd')}</TableCell>
                                        <TableCell className={this.props.classes.tableCell}>{row.businessPartnerName}</TableCell>
                                        <TableCell className={this.props.classes.tableCell}>{row.dispatchDestination}</TableCell>
                                        <TableCell className={this.props.classes.tableCell}>{row.dispatchNum}</TableCell>
                                        <TableCell className={this.props.classes.tableCell}>{Utility.statusToString(row.progressStatus)}</TableCell>
                                        {this.props.detailPath === '/cancelRequestDetail' && (
                                            <TableCell className={this.props.classes.tableCell} >
                                                {row.cancelReason && row.cancelReason.length > 15 ? (
                                                    <CustomTooltip title={row.cancelReason || ''} >                                                
                                                        <div className={this.props.classes.cancelReasonStyle}> {row.cancelReason.substring(0, 15) + '...'}</div>
                                                    </CustomTooltip>
                                                ) : (
                                                    <div>{row.cancelReason || ''}</div>
                                                )}
                                            </TableCell>
                                        )}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </div>
            );
        }
    }
}

export default withStyles(styles)(RequestListTable);